// api/applicationApi.js
import apiClient, { downloadFile } from "../../../../../../services/apiClient";
import { sendFileAsBinaryPOST } from "../../../../../../services/saveFile";


export const applicationApi = {
  // Получение заявки по ID
  getApplicationById: async (applicationId) => {
    const response = await apiClient.get(`/requests/${applicationId}`);
    return response.data && response.data[0] || {};
  },

  // Получение списка заявок с фильтрацией и пагинацией
  getApplications: async (filters = {}, page = 1, limit = 20) => {
    const params = {
      page,
      limit,
      ...filters
    };
    const response = await apiClient.get('/applications', { params });
    return response.data;
  },

  // Обновление статуса заявки
  updateApplicationStatus: async (applicationId, statusData) => {
    const response = await apiClient.put(`/applications/${applicationId}/status`, statusData);
    return response.data;
  },

  // Подтверждение регистрации
  verifyRegistration: async (applicationId, comment = '') => {
    const response = await apiClient.put(`/applications/${applicationId}/verify-registration`, {
      comment,
      verifiedBy: localStorage.getItem('userId')
    });
    return response.data;
  },

  // Подтверждение льготы
  verifyBenefit: async (applicationId, benefitId, comment = '') => {
    const response = await apiClient.put(`requests/${applicationId}/benefits_confirm`, {
      benefitId,
      comment,
      verifiedBy: localStorage.getItem('userId')
    });
    return response.data;
  },

  // Оновлення даних пільги модератором
  updateBenefits: async (applicationId, benefitsData) => {
    const response = await apiClient.put(`requests/${applicationId}/benefits`, {
      childBenefits: benefitsData,
      updatedBy: localStorage.getItem('userId')
    });
    return response.data;
  },

  // Отклонение заявки
  rejectApplication: async (applicationId, reason, comment = '') => {
    const response = await apiClient.put(`/applications/${applicationId}/reject`, {
      reason,
      comment,
      rejectedBy: localStorage.getItem('userId')
    });
    return response.data;
  },

  // Восстановление заявки
  restoreApplication: async (applicationId, comment = '') => {
    const response = await apiClient.put(`/applications/${applicationId}/restore`, {
      comment,
      restoredBy: localStorage.getItem('userId')
    });
    return response.data;
  },
  
  declineInvitation: async (applicationId, reason, kindergartenId, groupNumber) => {
    const response = await apiClient.post(`invite/request/${applicationId}/decline_request_invite_admin`, {
      reason,
      kindergartenId,
      groupNumber,
      declinedBy: localStorage.getItem('userId')
    });
    return response.data;
  },

  // Автоматична перевірка реєстрації через реєстр територіальної громади
  checkMR: async (applicationId, data) => {
    const response = await apiClient.post(`checkMR/${applicationId}`, data);
    return response.data;
  },

  // Ручне встановлення/скасування реєстрації
  setMR: async (applicationId, data) => {
    const response = await apiClient.put(`setMR/${applicationId}`, data);
    return response.data;
  },

  // Подовження терміну запрошення
  prolongInvite: async (requestId, newDateTo) => {
    const response = await apiClient.post('invite_prolong', { requestId, newDateTo });
    return response.data;
  },

  // Скасування пільги модератором
  declineBenefit: async (applicationId, description) => {
    const response = await apiClient.post(`requests/${applicationId}/decline_benefit`, {
      description,
    });
    return response.data;
  },

  // Видалення файлу пільги
  deleteFile: async (applicationId, fileId, section) => {
    const response = await apiClient.delete(`requests/${applicationId}/file/${fileId}/${section}`);
    return response.data;
  },

  // Завантаження файлу пільги через sendFileAsBinaryPOST
  // file — об'єкт від FileUploader: { type, name, size, file: "data:...base64..." }
  uploadBenefitFile: async (applicationId, fileObj) => {
    return await sendFileAsBinaryPOST({
      _id: applicationId,
      file: fileObj,        // sendFileAsBinaryPOST читає .file як тіло
      typedoc: "request",
      part: "benefits"
    });
  },

  getApplicationStatuses: async (applicationId) => {
    const response = await apiClient.get(`/requests/${applicationId}/statuses`);
    return response.data;
  }
};


const url_download = (docId, fileId, path)=>`requests/${docId}/file/${fileId}/${path}`;

export const fileApi = {
  // Скачивание файла
  downloadFile: async (docId, fileId, path, fileName) => await downloadFile(url_download(docId, fileId, path), fileName),

  // Получение информации о файле
  getFileInfo: async (fileId) => {
    const response = await apiClient.get(`/files/${fileId}/info`);
    return response.data;
  },

  // Загрузка файла
  uploadFile: async (applicationId, file, fileType) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('type', fileType);
    
    const response = await apiClient.put(`/applications/${applicationId}/files`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }
};